import styled from 'styled-components'

import { white } from '../../../utils/style-utils'

export const StyledDate = styled.h3`
  color: ${white};
`
